import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import Flickity from 'react-flickity-component';
import { formatParagraphs } from '../../../models/Utils';

import Infographic from '../PulseInfographic/Infographic';
import Location from '../PulseLocation/Location';
import './Pulse.scss';
import { ADAARIARoles } from '../../../models/ADA';

const Pulse = ({ content, active }) => {
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });
  const [activeLocation, setActiveLocation] = useState(null);
  const flickityRef = useRef(null);
  const choiceSelectedRef = useRef(null);
  const choiceUnselectedRef = useRef(null);
  const menuOpened = useSelector(state => state.data.menuOpened);

  useEffect(() => {
    setActiveLocation(null);
    selectIndex(0);
  }, [active]);

  const handleSelected = key => {
    if (content && content.Locations) {
      const match = content.Locations.find(x => x.Key === key);
      const index = content.Locations.findIndex(x => x.Key === key);
      if (match) {
        setActiveLocation(match);
        playFocusedText(choiceSelectedRef);
      } else {
        setActiveLocation(null);
        playFocusedText(choiceUnselectedRef);
      }
      selectIndex(index);
    }
  };

  const playFocusedText = (ref) => {
    if(ref !== null && ref.current !== null){
      ref.current.focus();
    }
  }

  const selectIndex = index => {
    if (flickityRef.current && index >= 0 && index < content.Locations.length) {
      flickityRef.current.select(index);
    }
  };

  if (!content) {
    return null;
  }

  const locations = [];
  if (content && content.Locations) {
    for (var i = 0; i < content.Locations.length; i++) {
      var location = content.Locations[i];
      if (location) {
        locations.push(
          <Location
            key={location.Key}
            isActive={active}
            location={location}
            activeKey={activeLocation ? activeLocation.Key : -1}
            onSelected={handleSelected}
          />
        );
      }
    }
  }

  const textBox = (
    <div className="location-text text-holder">
      {activeLocation ? (
        <>
          <div className="location-data" >
            <div className="speed">{activeLocation.WirelessBusyHour}</div>
            <div className="ada-hidden">:</div>
            <div className="volume">{activeLocation.VolumeRate}</div>
            <div className="instructions">{formatParagraphs(activeLocation.Description)}</div>
          </div>
        </>
      ) : null}
      <>
        <div className={activeLocation ? 'instructions-holder inactive' : 'instructions-holder active'}>
          <div className="body">{formatParagraphs(content.Body)}</div>
          <div className="instructions">{formatParagraphs(content.Description)}</div>
        </div>
      </>
    </div>
  );

  const centerContent = isPortrait ? (
    <>
      <Infographic barCount={activeLocation ? parseInt(activeLocation.Value, 10) : -1}
        altText={content.VerizonLogoAltText} active={active} />
      {textBox}
    </>
  ) : (
    <>
      {textBox}
      <Infographic barCount={activeLocation ? parseInt(activeLocation.Value, 10) : -1} 
        altText={content.VerizonLogoAltText} active={active} />
    </>
  );

  const flickityOptions = {
    initialIndex: 0,
    pageDots: false,
    prevNextButtons: false,
    cellAlign: 'center',
    accessibility: false,
    freeScroll: true,
    contain: true,
  };

  return (
    <div id="pulse" className="darkBg">
      <div className="wrapper">
        <div className="content-top">
          <div className="header" role={ADAARIARoles.Heading}>{content.Header}</div>
        </div>
        <div className="content-middle">{centerContent}</div>
        <div className="content-bottom">
          {locations}
        </div>
      </div>
    </div>
  );
};

export default Pulse;
